<template>
    <div>
        <div class="mb-3 text-right">
            <hts-form-button
                color="main"
                icon-name="hi-plus-circle-icon"
                icon-position="right"
                type="submit"
                @click="handleAddRouting">
                {{ $t('labels.routingModule.add') }}
            </hts-form-button>
        </div>
        <hts-data-table
            ref="dataTable"
            :headers="routingHeader"
            :server="server"
            :pagination="true"
            store-name="nodeDataTable"
            store-key="Node" />
        <hts-modal
            :show="showPopupDeleteRouting"
            :title="$t('labels.routingModule.deleteRouting')"
            type="confirm"
            :content="$t('labels.routingModule.deleteRoutingConfirm')"
            @hide="closePopupDeleteRouting"
            @confirm="handleDeleteRouting" />
    </div>
</template>

<script setup lang="ts">
import { formatTime } from './ignore/imports/utils'
import layoutPermissions from '@/data/permissions/layout-permissions'
import Actions from '@/pages/trucker-[id]/vehicle/ignore/actions.vue'
import { checkPermission } from '@/utils/permission-check'
const server = ref({})
const dataTable = ref()
const showPopupDeleteRouting = ref(false)
const routingId = ref(false)

const viewDetail = (routing: any) => {
  if (!routing) {
    return null
  }
  useRouter().push({
    name: 'trucker-id-routing-routing-detail',
    params: {
      id: routing._id
    }
  })
}
const editRouting = (routing: any) => {
  if (!routing) {
    return null
  }
  useRouter().push({
    name: 'trucker-id-routing-edit-routing',
    params: {
      id: routing._id
    }
  })
}
const handleActionDelete = (routing: any) => {
  if (!routing) {
    return null
  }
  showPopupDeleteRouting.value = true
  routingId.value = routing._id
}
const routingHeader = [
  {
    field: 'distance',
    headerName: $t('labels.distance'),
    sortable: true
  },
  {
    field: 'time',
    headerName: $t('labels.estimateTime'),
    sortable: true,
    valueGetter: (params: any) => {
      if (!params.data) {
        return null
      }
      return formatTime(params.data.time)
    }
  },
  {
    field: 'action',
    pinned: 'right',
    sortable: false,
    lockPosition: true,
    lockPinned: true,
    headerName: $t('labels.action'),
    cellStyle: { overflow: 'visible' },
    cellRenderer: Actions,
    cellRendererParams: {
      items: [
        {
          icon: 'hi-eye-icon',
          label: $t('labels.viewDetail'),
          class: 'text-blue-600 hover:text-blue-500',
          permissions: checkPermission(layoutPermissions.node_management),
          click: viewDetail
        },
        {
          icon: 'hi-pencil-icon',
          label: $t('labels.edit'),
          class: 'text-purple-600 hover:text-purple-500',
          permissions: checkPermission(layoutPermissions.node_edit),
          click: editRouting
        },
        {
          icon: 'hi-trash-icon',
          label: $t('labels.delete'),
          class: 'text-error-600 hover:text-error-500',
          permissions: checkPermission(layoutPermissions.node_delete),
          click: handleActionDelete
        }
      ]
    }
  }
]
onBeforeMount(() => {
  server.value = $url.routing.getList
})
const refreshTables = () => {
  if (dataTable.value) {
    dataTable.value.refresh()
  }
}
const handleAddRouting = () => {
  useRouter().push({
    name: 'trucker-id-routing-add-routing',
    params: {}
  })
}

const handleDeleteRouting = () => {
  const api = $url.routing.delete
  $api(api, { body: { id: routingId.value } })
    .then((data) => {
      if (!data) {
        return true
      }
      const responseData: any = data.data.value
      if (!responseData) {
        return true
      }
      if (responseData.success) {
        refreshTables()
        process.client && $toast().success($t('labels.routingModule.deleteSuccess'))
        closePopupDeleteRouting()
      }
    })
    .catch((error: any) => error)
}
const closePopupDeleteRouting = () => {
  showPopupDeleteRouting.value = false
}
</script>
